import { Component, output } from '@angular/core';
import { IActionButtonData } from '../action-button/IActionButtonData.model';
import { MaterialModule } from 'src/app/material.module';
import { ActionButtonComponent } from '../action-button/action-button.component';

@Component({
  selector: 'cgw-carousel-arrows',
  standalone: true,
  imports: [MaterialModule, ActionButtonComponent],
  templateUrl: './carousel-arrows.component.html',
  styleUrl: './carousel-arrows.component.scss',
})
export class CarouselArrowsComponent<T> {
  public readonly onPrevious = output<void>();
  public readonly onNext = output<void>();

  public readonly arrowLeftButton: IActionButtonData = {
    icon: 'keyboard_arrow_left',
    type: 'secondary',
    action: () => {
      this.onPrevious.emit();
    },
  };
  public readonly arrowRightButton: IActionButtonData = {
    icon: 'keyboard_arrow_right',
    type: 'secondary',
    action: () => {
      this.onNext.emit();
    },
  };
}
